import React, { useMemo } from "react";
import {
  Card,
  Space,
  Button,
  Typography,
  Progress,
  Statistic,
  Divider,
} from "antd";
import {
  FileTextOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
  CalendarOutlined,
  ScheduleOutlined,
  CompassOutlined,
} from "@ant-design/icons";
import useCommonsService from "../../../../services/useCommonsService";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../../../utils/routes";

const { Text, Title } = Typography;

const buttonIcons = [
  <CalendarOutlined />,
  <ScheduleOutlined />,
  <CompassOutlined />,
];

export default function PersonnelHomePageSummaryCard() {
  const navigate = useNavigate();
  const { useGetLabelKeys } = useCommonsService();
  const { data: labelKeys } = useGetLabelKeys();

  const labelKeysForButtons = useMemo(() => {
    return labelKeys?.slice(3, 7) || [];
  }, [labelKeys]);

  const goToListingsPage = (item) => {
    navigate(PageRoutes.listings, {
      state: { labelKey: item.value, title: item.label },
    });
  };

  return (
    <div style={{ display: "flex", margin: "auto", justifyContent: "center" }}>
      <Card title={<Title level={4}>Özet</Title>} style={cardStyle}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <div style={statStyle}>
            <FileTextOutlined style={iconStyle} />
            <Statistic title="Başvurulan ilanlar" value={5} />
          </div>
          {/* <div style={statStyle}>
            <CloseCircleOutlined style={{ ...iconStyle, color: "#ff4d4f" }} />
            <Statistic title="Red Alınan İlanlar" value={7} />
          </div> */}
          <div style={statStyle}>
            <CheckCircleOutlined style={{ ...iconStyle, color: "#52c41a" }} />
            <Statistic title="Kabul Alınanan İlanlar" value={8} />
          </div>

          <Divider style={{ margin: 10, height: 0 }} />

          <div>
            <Text strong>Profil Doluluk Oranı</Text>
            <Progress percent={75} status="active" strokeColor="#1890ff" />
          </div>

          <Divider style={{ margin: 10, height: 0 }} />

          {labelKeysForButtons.map((item, index) => (
            <Button
              onClick={() => {
                goToListingsPage(item);
              }}
              key={item.value || index}
              type="primary"
              icon={buttonIcons[index]}
              style={buttonStyle}>
              {item.label + " İşleri Görüntüle"}
            </Button>
          ))}

          {/* <Button
            type="primary"
            icon={<CalendarOutlined />}
            style={buttonStyle}>
            Günlük İşleri Görüntüle
          </Button>
          <Button
            type="primary"
            icon={<ScheduleOutlined />}
            style={buttonStyle}>
            Haftalık İşleri Görüntüle
          </Button>
          <Button type="primary" icon={<CompassOutlined />} style={buttonStyle}>
            Bana Uygun İş İlanları
          </Button> */}
        </Space>
      </Card>
    </div>
  );
}

const cardStyle = {
  width: "90%",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.1)",
  borderRadius: "8px",
  marginTop: "20px",
};

const statStyle = {
  display: "flex",
  alignItems: "center",
  marginBottom: "10px",
};

const iconStyle = {
  fontSize: "24px",
  marginRight: "16px",
  color: "#1890ff",
};

const buttonStyle = {
  width: "100%",
  marginBottom: "12px",
  height: "50px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingLeft: "16px",
};
